var _path, _rect, _rect2, _rect3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLassoMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 54,
    viewBox: "0 0 128 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 64.9998C14.3333 55.3331 69.0346 20.5543 93 18.5C128 15.4998 145.5 49.9999 96.5 49.9999C57.3 49.9999 29 22.5 36.5 -8",
    stroke: "#3063E4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.0382,
    y: 5.81844,
    width: 1.63687,
    height: 7.52525,
    rx: 0.818435,
    fill: "#58595B",
    stroke: "#787E8A",
    strokeWidth: 1.63687
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0995533,
    y: 1.0827,
    width: 1.5929,
    height: 5.38101,
    rx: 0.79645,
    transform: "matrix(0.790247 0.612788 -0.665251 0.74662 91.5615 9.28473)",
    fill: "#58595B",
    stroke: "#787E8A",
    strokeWidth: 1.5929
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.0995533,
    y: 1.0827,
    width: 1.5929,
    height: 5.38101,
    rx: 0.79645,
    transform: "matrix(-0.790247 0.612788 0.665251 0.74662 67.9941 9.40674)",
    fill: "#58595B",
    stroke: "#787E8A",
    strokeWidth: 1.5929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8802 20.0625H83.4323C93.3032 20.0625 101.312 28.1307 101.312 38.1055V60.957C101.312 70.9306 93.3008 79 83.4323 79H75.8802C66.0116 79 58 70.9317 58 60.957V38.1055C58 28.1308 66.0116 20.0625 75.8802 20.0625ZM79.6562 42.9141C82.3114 42.9141 84.4323 40.7261 84.4323 37.9984V34.1898C84.4323 31.5485 82.2958 29.3812 79.6562 29.3812C77.0167 29.3812 74.8802 31.5485 74.8802 34.1898V37.9984C74.8802 40.7261 77.0011 42.9141 79.6562 42.9141Z",
    fill: "white",
    stroke: "#787E8A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLassoMode);
export default __webpack_public_path__ + "static/media/lassoMode.d43f6f03849999b822cd7131e130e23c.svg";
export { ForwardRef as ReactComponent };